import * as Blockly from 'blockly';
import * as python from 'blockly/python'
import { BlockLogo } from 'src/app/shared/enums/SequenceKeys.enum';
import { BlockColors } from '../blockly-theme';


export const MODEL_POINTS_BLOCKS = [
{
    type: "point_setter",
    message0: "%1 set %2 %3 %4 to %5",
    args0: [
      {
        "type": "field_image",
        "src": BlockLogo.IMAGE,
        "width": BlockLogo.WIDTH,
        "height": BlockLogo.HEIGHT,
        "alt": BlockLogo.ALT_TEXT
      },
      {
        type: "field_dropdown",
        name: "selected_point_name",
        options: [
          [
            "select point",
            "DEFAULT_MODAL"
          ]
        ]
      },
      {
        "type": "field_input",
        "name": "selected_point_ref"
      },
      {
        "type": "field_input",
        "name": "setter_model_value",
      },
      {
        "type": "input_value",
        "name": "input_value_field",
        "check": "Number"
      },
    ],
    "previousStatement": null,
    "nextStatement": null,
    "inputsInline":false,
    "colour": BlockColors.MODEL_POINTS,
    "tooltip": "Setter for the modal point",
    "helpUrl": "",
  }
];

export class dynamicDeviceModelBlockBuilder {
  static modelPointBlockInit(block: any) {
    Blockly.Blocks[block.type] = {
      init: function () {
        this.appendDummyInput()
        .appendField(this.getBlockImage(), 'blockImage')
        .appendField(new Blockly.FieldLabel(block.label), 'pointName')
        .appendField(new Blockly.FieldLabel(block.id), 'pointId')
        .appendField(new Blockly.FieldLabel(block.defaultValue ?? null), 'defaultValue');
        this.setOutput(true);
        this.setColour(BlockColors.MODEL_POINTS);
        this.setHelpUrl('');
        (this as any).defaultValue = block.defaultValue ?? null;
        this.updateBlockShape();

      },

      // Create an image field with specified source, width, and height
      getBlockImage() {
        const src = BlockLogo.IMAGE;
        const width = BlockLogo.WIDTH;
        const height = BlockLogo.HEIGHT;
        const alt = BlockLogo.ALT_TEXT
        return new Blockly.FieldImage(src, width, height, alt);
      },

      // Hiding the xml and snippet fields of the block.
      updateBlockShape: function() {
        this.getField('pointId').setVisible(false);
        this.getField('defaultValue').setVisible(false);
      }
    }
    
    // Code generation
    python.pythonGenerator.forBlock[block.type] = function (block: any, generator: any) {
      var modelPointVariableName = block.getFieldValue('pointName');
      var type = 1;
      var dataType = 1; //int=0, float=1
      var port = modelPointVariableName.slice(modelPointVariableName.lastIndexOf('_') + 1);
      var code = `connmod.ReadDataTypeRegister(${dataType},${type}, ${port})`;
      return [code, python.Order.ATOMIC];
    };
  };
}